
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import { PageHeader } from '../components'
import { Alert } from '@/components'
import { SaveButton, DeleteButton } from '@/components/buttons'
import { SchoolTeacherDto } from '@ViewModels/SchoolTeacherDto'
import TeacherDetailsForm from './forms/TeacherDetailsForm.vue'

export default Vue.extend({
   name: 'TeacherDetails',
   props: {
      schoolId: { type: String, default: '' },
      teacherId: String,
   },
   data() {
      return {
         editingItem: {} as SchoolTeacherDto,
         subscriptions: [],
         schoolAdmins: [] as string[],
         saving: false,
      }
   },
   computed: {
      activeSchoolId(): string {
         return this.schoolId ? this.schoolId : this.$store.getters.activeSchoolId
      },
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      userIsSchoolAdmin(): boolean {
         return this.$store.getters.userIsSchoolAdmin
      },
      administratorNamesMessage(): string {
         return (
            `Only your school administrators can make changes to these settings.<br/>Your school administrators are: ` +
            this.schoolAdmins.join(', ')
         )
      },
      canEdit(): boolean {
         return this.userIsiUgoAdmin || this.userIsSchoolAdmin
      },
      canSave(): boolean {
         return !!this.editingItem
      },
      crumbs(): Breadcrumb[] {
         return [
            {
               text: 'Teachers',
               route: 'teacher-list',
               params: { schoolId: this.activeSchoolId },
            },
            { text: this.editingItem.Name },
         ]
      },
   },
   mounted() {
      this.loadItem()
   },
   methods: {
      async saveItem() {
         try {
            this.saving = true
            await Api.saveSchoolTeacher(this.editingItem)
            this.$router.push({
               name: 'teacher-list',
               params: { schoolId: this.activeSchoolId },
            })
         } catch {
            this.saving = false
         }
      },

      async loadItem() {
         const item = await Api.getSchoolTeacher(this.teacherId)
         Vue.$assign(this.editingItem, item)

         this.subscriptions = await Api.getCurrentPartySubscriptions(item.PartyId)

         this.schoolAdmins = await Api.getAdministratorNamesForSchool(this.activeSchoolId)
      },
   },
   components: {
      Alert,
      PageHeader,
      DetailsForm: TeacherDetailsForm,
      SaveButton,
      DeleteButton,
   },
})
